/**
 * @private
 *
 * @description
 * Получаем нужный элемент из шаблона
 */
export default (template, node, single = true, allContent = false) => {
  if (allContent) {
    return template.content.cloneNode(true);
  }

  if (single) {
    let selector = template.content.querySelector(node);

    return selector ? selector.cloneNode(true) : null;
  }

  let templateNodes = [];

  Array.from(template.querySelectorAll(node)).forEach(item => {
    item.push(templateNodes);
  });

  return templateNodes.length ? templateNodes : null;
};
